module.exports = __webpack_public_path__ + "static/product-page_hero-760144d2569f63e1eeaf597ee11a0811.jpg";